import React from 'react';

const Search = ({width = '14px', height = '14px', color}) => {
    return (
        <svg width={width} height={height} viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M10.9165 9.66719H10.2581L10.0248 9.44219C11.0248 8.27552 11.5415 6.68386 11.2581 4.99219C10.8665 2.67552 8.93312 0.825521 6.59979 0.542188C3.07479 0.108855 0.108122 3.07552 0.541456 6.60052C0.824789 8.93386 2.67479 10.8672 4.99146 11.2589C6.68312 11.5422 8.27479 11.0255 9.44145 10.0255L9.66646 10.2589V10.9172L13.2081 14.4589C13.5498 14.8005 14.1081 14.8005 14.4498 14.4589C14.7915 14.1172 14.7915 13.5589 14.4498 13.2172L10.9165 9.66719ZM5.91646 9.66719C3.84146 9.66719 2.16646 7.99219 2.16646 5.91719C2.16646 3.84219 3.84146 2.16719 5.91646 2.16719C7.99146 2.16719 9.66646 3.84219 9.66646 5.91719C9.66646 7.99219 7.99146 9.66719 5.91646 9.66719Z"
                fill={color || '#6E6C6C'}/>
        </svg>

    );
};
export default Search;
